import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ReadMoreReadLess = ({
  children,
  charLimit = 200,
  readMoreText = 'Read more',
  readLessText = 'Read less',
  readMoreClassName = '',
  readLessClassName = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!children || children.length <= charLimit) {
    return <span>{children}</span>;
  }

  const truncatedText = children.slice(0, charLimit);

  return (
    <span>
      {isExpanded ? children : `${truncatedText}...`}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={isExpanded ? readLessClassName : readMoreClassName}
        style={{
          background: 'none',
          border: 'none',
          color: 'inherit',
          cursor: 'pointer',
          textDecoration: 'underline',
          marginLeft: '5px'
        }}
      >
        {isExpanded ? readLessText : readMoreText}
      </button>
    </span>
  );
};

ReadMoreReadLess.propTypes = {
  children: PropTypes.string.isRequired,
  charLimit: PropTypes.number,
  readMoreText: PropTypes.string,
  readLessText: PropTypes.string,
  readMoreClassName: PropTypes.string,
  readLessClassName: PropTypes.string
};

export default ReadMoreReadLess; 